import { useCallback, useContext } from 'react';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-pro';

import { Tooltip } from '@mui/material';
import { SelectDate, SelectDateEventType } from '../SelectDate';
import { GridRowContext } from './PhoenixGrid';

interface IGridColDataInputProps {
  params: GridRenderEditCellParams;
  onChange?: (event: SelectDateEventType) => void;
  disabled?: boolean;
}

export const GridColDate = ({ params, onChange, disabled = false }: IGridColDataInputProps) => {
  const api = useGridApiContext();
  const rowContext = useContext(GridRowContext);

  const { id, field, value = '' } = params;

  const handleChange = useCallback(
    (event: SelectDateEventType) => {
      if (rowContext.errors[field]) {
        rowContext.resetError(field);
      }

      api.current.setEditCellValue({ id, field, value: event.target.value });
      onChange?.(event);
    },
    [id, field]
  );

  return (
    <Tooltip title={rowContext.errors[field]}>
      <div>
        <SelectDate
          defaultValue=""
          value={value}
          error={!!rowContext.errors[field]}
          disabled={disabled}
          onChange={handleChange}
        />
      </div>
    </Tooltip>
  );
};
